export default __webpack_public_path__ + "static/media/arrow-left-s-line-1.8f8d650a.svg";